import { OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { FactoryBase } from '../../../interfaces';
import { FormGroup } from '@angular/forms';
import { throwError } from 'rxjs';
import { CrudComponent } from '../../../components/crud/crud.component';

export abstract class PageComponent<T> extends CrudComponent implements OnInit, OnDestroy, OnChanges {
  @Input() public readonly model: T;

  @Output() public change: EventEmitter<T> = new EventEmitter<T>();

  @Output() public valid: EventEmitter<boolean> = new EventEmitter<boolean>();

  public form: FormGroup;

  protected readonly factory: FactoryBase<T>;

  constructor(factoryInstantce: FactoryBase<T>) {
    super();
    this.factory = factoryInstantce;
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.model) {
      this.initForm();
    }
  }

  public ngOnInit(): void {
    this.initForm();
  }

  private initForm() {
    if (!this.factory.getFormGroup) {
      throwError("The factory doesn't have the getFormGroup implementation.");
      return;
    }

    this.form = this.factory.getFormGroup(this.model);

    this.destroyableSubscriptions.push(this.form.valueChanges.subscribe(() => this.onChange()));

    if (this.isView) {
      this.form.disable();
    }
  }

  public onChange(): void {
    this.valid.emit(this.form.valid);

    if (this.form.invalid) {
      return;
    }

    if (!this.factory.loadFromFormGroup) {
      throwError("The factory doesn't have the loadFromFormGroup implementation.");
      return;
    }

    this.change.emit(this.factory.loadFromFormGroup(this.model, this.form));
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
  }
}
